module.exports = __webpack_public_path__ + "static/media/vf_mpants_core.41e78173.svg";